import { render, staticRenderFns } from "./BigScreen.vue?vue&type=template&id=0bc327b4&scoped=true"
import script from "./BigScreen.vue?vue&type=script&lang=js"
export * from "./BigScreen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc327b4",
  null
  
)

export default component.exports